/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs */

const en_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your photos are never shared. Digital copies remain encrypted.`)
};

const es_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus fotos nunca se comparten. Las copias digitales permanecen cifradas.`)
};

const fr_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos photos ne sont jamais partagées. Les copies numériques restent cryptées.`)
};

const de_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Fotos werden niemals geteilt. Digitale Kopien bleiben verschlüsselt.`)
};

const ja_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの写真が共有されることはありません。デジタルコピーは暗号化されたままです。`)
};

const zh_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的照片绝不会被分享。数字副本始终保持加密。`)
};

const ar_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يتم مشاركة صورك أبدًا. تظل النسخ الرقمية مشفرة.`)
};

const id_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto Anda tidak akan pernah dibagikan. Salinan digital tetap terenkripsi.`)
};

const it_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue foto non vengono mai condivise. Le copie digitali rimangono crittografate.`)
};

const ru_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши фотографии никогда не передаются другим. Цифровые копии остаются зашифрованными.`)
};

const pt_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As suas fotos nunca são partilhadas. As cópias digitais permanecem encriptadas.`)
};

const ko_your_photos_are_never_shared_digital_copies_remain = /** @type {(inputs: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회원님의 사진은 절대 공유되지 않습니다. 디지털 사본은 암호화되어 안전하게 유지됩니다.`)
};

/**
* | output |
* | --- |
* | "Your photos are never shared. Digital copies remain encrypted." |
*
* @param {Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_photos_are_never_shared_digital_copies_remain = /** @type {((inputs?: Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Photos_Are_Never_Shared_Digital_Copies_RemainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "es") return es_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "fr") return fr_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "de") return de_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "ja") return ja_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "zh") return zh_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "ar") return ar_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "id") return id_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "it") return it_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "ru") return ru_your_photos_are_never_shared_digital_copies_remain(inputs)
	if (locale === "pt") return pt_your_photos_are_never_shared_digital_copies_remain(inputs)
	return ko_your_photos_are_never_shared_digital_copies_remain(inputs)
});